// library imports
import React, { useEffect, useRef } from "react";

import CloseButton from "_core/components/common/UI/CloseButton";
import './OpsDialog.scss';

// 開いているダイアログの順序（Escape は最前面のダイアログだけを閉じる）
const openStack = [];

/**
 * 運営ツールの大きいモーダル（ヘッダー64px・本文・フッター）
 * 閉じ方は CLAUDE.md「モーダルの閉じ方ルール」に従い、呼び出し側が showClose / onBackdropClick を決める。
 * onBackdropClick 未指定なら onClose を呼んで閉じる（既存 Modal と同じ既定）。
 */
const OpsDialog = ({ show, title, subtitle, width = 900, height, headerRight, footer, footerClassName = "", showClose = true, onClose, onBackdropClick, className = "", bodyClassName = "", children }) => {
    const idRef = useRef({});
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;

    useEffect(() => {
        if (!show) return undefined;
        const id = idRef.current;
        openStack.push(id);
        const onKeyDown = (e) => {
            if (e.key !== 'Escape' || openStack[openStack.length - 1] !== id) return;
            e.stopPropagation();
            if (onCloseRef.current) onCloseRef.current();
        };
        window.addEventListener('keydown', onKeyDown);
        return () => {
            window.removeEventListener('keydown', onKeyDown);
            const index = openStack.indexOf(id);
            if (index >= 0) openStack.splice(index, 1);
        };
    }, [show]);

    if (!show) return null;

    const handleBackdrop = (e) => {
        if (e.target !== e.currentTarget) return;
        if (onBackdropClick) onBackdropClick();
        else if (onClose) onClose();
    };

    return (
        <div className={"ops-dialog-overlay " + className} onMouseDown={handleBackdrop} data-ops-modal="1">
            <div className="ops-dialog" style={{ maxWidth: width, height: height }}>
                <div className="ops-dialog-header">
                    <div className="ops-dialog-title-area">
                        <div className="ops-dialog-title">{title}</div>
                        {subtitle && <div className="ops-dialog-subtitle">{subtitle}</div>}
                    </div>
                    <div className="ops-dialog-header-right">
                        {headerRight}
                        {showClose &&
                            <CloseButton className="ops-dialog-close" onClick={onClose} />
                        }
                    </div>
                </div>
                <div className={"ops-dialog-body " + bodyClassName}>{children}</div>
                {footer && <div className={"ops-dialog-footer " + footerClassName}>{footer}</div>}
            </div>
        </div>
    );
};

export default OpsDialog;
